__turbopack_context__.v({
  "nari-points": "NariPoints-module__LJL7_q__nari-points",
  "nari-points-1": "NariPoints-module__LJL7_q__nari-points-1",
  "nari-points-100": "NariPoints-module__LJL7_q__nari-points-100",
  "nari-points-1000": "NariPoints-module__LJL7_q__nari-points-1000",
  "nari-points-10000": "NariPoints-module__LJL7_q__nari-points-10000",
  "nari-points-100000": "NariPoints-module__LJL7_q__nari-points-100000",
  "nari-points-5000": "NariPoints-module__LJL7_q__nari-points-5000",
  "nari-points-icon": "NariPoints-module__LJL7_q__nari-points-icon",
});
